export const columns = [
  {
    customWidth: 140,
    Header: () => 'Product Code',
    accessor: 'sku',
    Cell: ({ row }) => <div>{row.original.sku}</div>,
  },
  {
    customWidth: 230,
    Header: () => 'Product Name',
    accessor: 'description',
    Cell: ({ row }) => <div>{row.original.description}</div>,
  },
  {
    customWidth: 60,
    Header: 'Order Qty',
    accessor: 'qty',
    Cell: ({ row }) => <div>{row.original.qty}</div>,
  },
  {
    customWidth: 63,
    Header: 'Picked Qty',
    accessor: 'pickedQty',
    isEditableInput: true,
  },
  {
    customWidth: 63,
    Header: () => '',
    accessor: 'actions',
    isAction: true,
  },
]

export default columns
